import { Vue, prop } from 'vue-class-component';
import { Button, ButtonTypes } from '@/components/button';
import { Inject } from 'vue-property-decorator';
import type { VueI18n } from 'vue-i18n';
import { Routes } from '@/router/routes';
import { AMPLITUDE_LABELS } from '@/common';
import { CoreModuleContext } from '@/store/core';
import styles from './styles.module.scss';

class DealOptionsProps {
	zip = prop<string | undefined>({ default: undefined })

	path = prop<string>({ default: Routes.ERROR.path })
}

export class DealOptions extends Vue.with(DealOptionsProps) {
	@Inject() readonly i18n!: VueI18n;

	@Inject() readonly coreModule!: CoreModuleContext;

	triggerEvent() {
		const eventData = {
			Label: AMPLITUDE_LABELS.customizeDeal,
			Action: 'Zipcode',
			...this.$route.meta,
		};

		this.coreModule.actions.sendEvent(eventData);
	}

	render() {
		return (
			<div class={ styles.dealOptions }>
				<div class={ styles.dealOptionsTitle }>
					{ this.i18n.t('dealOptions.title') }
				</div>
				<div class={ styles.dealOptionsDescription }>
					{ this.i18n.t('dealOptions.zipText') }
					{' '}
					<Button to={ this.path } type={ ButtonTypes.link } inline={ true } onClick = { this.triggerEvent }>
						{ this.zip }
					</Button>
				</div>
			</div>
		);
	}
}
